import { PropertiesTableProps } from '../../../../shared/types'

export const WizardButtonsProperties: PropertiesTableProps = {
  '[ButtonRow](/uilib/extensions/forms/Form/ButtonRow/properties/)': {
    doc: 'ButtonRow properties.',
    type: 'Various',
    status: 'optional',
  },
}
